import React from 'react';
import { Mic, Volume2, HardDrive, Cloud } from 'lucide-react';
import './AdminAudioCard.css';

const AdminAudioCard = ({ stats }) => {
  // 🔥 CORRECCIÓN ROBUSTA:
  const piperData = stats?.piper || { chars: 0, cost: 0 };
  const openaiData = stats?.openai || { chars: 0, cost: 0 };
  const totalChars = stats?.total_chars || 0;

  // Calcular porcentajes (protegido contra división por cero)
  const safeTotal = totalChars > 0 ? totalChars : 1;
  const piperPercent = (piperData.chars / safeTotal) * 100;
  const openaiPercent = (openaiData.chars / safeTotal) * 100;

  // Formateo visual del total
  const displayTotal = totalChars > 0 ? (totalChars / 1000).toFixed(1) + 'k' : '0';

  return (
    <div className="ad-card ad-audio-card">
      <div className="ad-audio-header">
        <div className="ad-kpi-icon audio">
          <Volume2 size={24} />
        </div>
        <div>
          <h3>Generación de Voz</h3>
          <p>Distribución de Modelos TTS</p>
        </div>
        <div className="ad-audio-total">
            <strong>{displayTotal}</strong>
            <span>caracteres</span>
        </div>
      </div>

      {/* Barra de Progreso Híbrida */}
      <div className="ad-audio-bar-container">
        <div className="ad-audio-bar piper" style={{ width: `${piperPercent}%` }}></div>
        <div className="ad-audio-bar openai" style={{ width: `${openaiPercent}%` }}></div>
      </div>

      {/* Leyenda y Datos */}
      <div className="ad-audio-legend">
        
        {/* Piper */}
        <div className="ad-legend-item">
            <div className="ad-dot piper"></div>
            <div className="ad-legend-info">
                <div className="legend-title">
                    <HardDrive size={12} /> Piper (Local)
                </div>
                <div className="legend-stats">
                    <span>{piperData.chars.toLocaleString()} chars</span>
                    <span className="free-tag">GRATIS</span>
                </div>
            </div>
        </div>

        {/* OpenAI */}
        <div className="ad-legend-item">
            <div className="ad-dot openai"></div>
            <div className="ad-legend-info">
                <div className="legend-title">
                    <Cloud size={12} /> OpenAI (Cloud)
                </div>
                <div className="legend-stats">
                    <span>{openaiData.chars.toLocaleString()} chars</span>
                    {/* ✅ FIX: Ahora usamos openaiData.cost */}
                    <span className="cost-tag">${openaiData.cost.toFixed(4)}</span>
                </div>
            </div>
        </div>

      </div>
    </div>
  );
};

export default AdminAudioCard;